export default __webpack_public_path__ + "static/media/elk.bd5fe0a7.jpg";